<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <!-- <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div> -->

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <feather-icon icon="CheckIcon" v-if="checkFalg"/>
        <h2 style="width:50%"> {{showDate}} </h2>
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="검색" />
        <datepicker class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-2 sm:mt-0 mt-2" placeholder="날짜" :language="$vs.rtl ? langHe : langEn" v-model="selectDate"  format="yyyy년 MMM dd일" :highlighted="highlightedFn"/>
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <!-- <vs-dropdown vs-trigger-click class="cursor-pointer"> -->
          <div class="p-1 rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-20">
            <vs-button class="badge" v-if="activeUserLevel >= 3" type="gradient" style="margin-left:-5px; margin-right:2px; margin-bottom:5px; font-size:14px;" color="dark" @click="saveWorksacpeInfo()">저장</vs-button>
          </div>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage"/>
    </div>
  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import { ko, he } from "vuejs-datepicker/src/locale"
// Store Module
// import moduleAttend from '@/store/attend/moduleAttend.js'

// Cell Renderer
import AttendLink from "./cell-renderer/AttendLink.vue"
import AttendStatus from "./cell-renderer/AttendStatus.vue"
import AttendTotal from "./cell-renderer/AttendTotal.vue"
import AttendActions from "./cell-renderer/AttendActions.vue"


export default {
  components: {
    AgGridVue,
    vSelect,
    AttendLink,
    AttendStatus,
    AttendTotal,
    AttendActions,
    Datepicker
  },
  data() {
    return {
      days:[],
      showDate:null,
      selectDate: new Date(),
      highlightedFn: {},
      langHe: he,
      langEn: ko,
      searchQuery: "",
      checkFalg: false,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: [
        {
          headerName: '이름',
          field: 'name',
          width: 101,
          cellRendererFramework: 'AttendLink'
        },
        {
          headerName: '오늘',
          field: 'state',
          width: 101,
          cellRendererFramework: 'AttendStatus'
        },
        {
          headerName: '전체',
          field: 'total',
          width: 200,
          cellRendererFramework: 'AttendTotal'
        },
        {
          headerName: '이메일',
          field: 'email',
          width: 200,
        },
      ],
      // Cell Renderer Components
      components: {
        AttendLink,
        AttendStatus,
        AttendTotal,
        AttendActions,
      },
      usersData:[]
    }
  },
  watch:{
    selectDate(){
      this.showDate = this.$moment(this.selectDate).format('YYYY-MM-DD')
      this.checkDays()
    }
  },

  computed: {
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    activeWorkspace() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    workspaceMembers() {
      return this.$store.state.space.workspaceMembers
    },
    attendDays(){
      return this.$store.state.attend.attendDays
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    attendMissDatas(){
      return this.$store.state.attend.attendMissDatas
    },
    attendLateDatas(){
      return this.$store.state.attend.attendLateDatas
    }
  },
  methods: {
    checkDays(){
      var attend = this.$store.getters['attend/getAttendDay'](this.showDate)
      if(attend){
        this.checkFalg = true
      }else{
        this.checkFalg = false
      }
      if(attend && (attend.miss_count != 0 || attend.late_count != 0)){
        this.$store.dispatch("attend/getAttendData", attend.id).then(()=>{
          this.$store.commit('attend/CHANGE_DATE_EVENT')
        })
      } else {
          this.$store.commit('attend/SET_ATTEND_MISS_DATA', [])
          this.$store.commit('attend/SET_ATTEND_LATE_DATE', [])
          this.$store.commit('attend/CHANGE_DATE_EVENT')
      }
    },
    saveWorksacpeInfo(){

      var attend = this.$store.getters['attend/getAttendDay'](this.showDate)
      if(!attend){
        var obj = {workspace_id:this.activeWorkspace.id, miss_count:this.attendMissDatas.length, late_count:this.attendLateDatas.length,
          day:this.showDate, miss_students:this.attendMissDatas, late_students:this.attendLateDatas}
        this.$store.dispatch("attend/createAttendData", obj).then(()=>{
          for (var index in this.attendDays){
            this.days.push(new Date(this.attendDays[index].day_time))
          }
          this.setAttendDay()
          this.$vs.notify({
            color: 'success',
            title: '저장',
            text: this.$moment(this.selectDate).format('MM월DD일')+' 출석부가 저장되었습니다'
          })
        })
      }else{
        var obj2 = {id:attend.id, workspace_id:this.activeWorkspace.id,  miss_count:this.attendMissDatas.length, late_count:this.attendLateDatas.length,
          day:this.showDate, miss_students:this.attendMissDatas, late_students:this.attendLateDatas}
        this.$store.dispatch("attend/updateAttendData", obj2).then(()=>{
          // this.setAttendDay()
          this.$store.commit('attend/UPDATE_DATA_EVENT')
          this.$vs.notify({
            color: 'success',
            title: '수정',
            text: this.$moment(this.selectDate).format('MM월DD일')+' 출석부가 수정되었습니다'
          })
        })
      }
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    setUserData(members, day){
      var attendDay = this.attendDays.findIndex(val => {return val == day})
      if(attendDay == -1){
        for(var index in members){
          var item = members[index]
          if(item.level < 3){
            this.usersData.push({user_id:item.user_id, name:item.name, state:1, total:item.id,  email:item.email})
          }
        }
      }
    },
    setAttendDay(){
      this.highlightedFn = {dates:this.days}
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
  },
  created() {
    this.showDate = this.$moment(this.selectDate).format('YYYY-MM-DD')
    // this.$store.commit('attend/SET_DAY', this.$moment(this.selectDate).format('YYYY-MM-DD'))
    this.$store.dispatch("attend/getAttendDay", this.activeWorkspace.id).then(()=>{
      // this.setAttendDay()
      for (var index in this.attendDays){
        this.days.push(new Date(this.attendDays[index].day_time))
      }
      this.checkDays()
      this.setAttendDay()
      if(this.activeUserLevel > 2){
        this.setUserData(this.workspaceMembers, this.selectDate)
      }
    }).catch((err) => { console.error(err) })
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.badge {
   display: inline-block;
   position: relative;
   padding: 2px;
   border: 1px solid black;
   color: #fff;
   font-weight: 700;
   font-size: 14px;
   animation: blink-animation 1s steps(5, start) infinite alternate;
   -webkit-animation: blink-animation 1s steps(5, start) infinite alternate;
}
@keyframes blink-animation {
   from {
       visibility: visibility;
   }
   to {
       visibility: hidden;
   }
}
@-webkit-keyframes blink-animation {
   from {
       visibility: visibility;
   }
   to {
       visibility: hidden;
   }
}
</style>
